// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const getDataForProjectType =
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(projectType: 'service_desk' | 'customer_service') => async (): Promise<any> => {
		try {
			return await performGetRequest(
				`/rest/servicedesk/admin/1/customer-access/settings/open-projects?projectType=${projectType}`,
			);
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			await fireErrorAnalytics({
				error,
				meta: {
					id: 'jsmGlobalCustomerAccessAffectedProjectsResource',
					packageName: 'jiraRouterResourcesAdminPagesJsmCustomerAccess',

					teamName: 'jsm-banana',
				},
			});
			throw error;
		}
	};

export default getDataForProjectType;
